import PaidIcon from '@material-ui/icons/MonetizationOn';
import PaidEdit from './PaidEdit';

export default {
  edit: PaidEdit,
  icon: PaidIcon,
};
